import { Component, input, output } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { IconComponent, LogoComponent } from '@shared/components';

/** Mobile-only bar: logo and the menu button. From lg up the sidebar carries everything. */
@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.css'],
    host: { class: 'theme-dark' },

    imports: [RouterLink, TranslatePipe, IconComponent, LogoComponent],
})
export class HeaderComponent {
    readonly menuOpen = input.required<boolean>();
    readonly menuToggle = output();
}
